import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const BASE_URL = 'http://localhost:8000'

export const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env['VITE_URL_BACKEND'],
  prepareHeaders(headers) {
    return headers
  },
})
